import {
  TextField, InputAdornment, IconButton, Stack, FormControlLabel, Switch, Tooltip,
} from '@mui/material';
import { AutoFixHigh } from '@mui/icons-material';
import { slugifyDocumentCode } from '../../utils/documentReviewUtils';

interface Props {
  label?: string;
  value: string;
  name: string;
  error?: string;
  disabled?: boolean;
  autoCode: boolean;
  onAutoCodeChange: (on: boolean) => void;
  onChange: (code: string) => void;
}

export default function DocumentCodeField({
  label = 'Code',
  value,
  name,
  error,
  disabled = false,
  autoCode,
  onAutoCodeChange,
  onChange,
}: Props) {
  const showAutoControls = !disabled;

  return (
    <TextField
      label={label}
      fullWidth
      required
      value={value}
      disabled={disabled}
      error={!!error}
      helperText={
        error
        || (disabled
          ? 'Code cannot be changed after create'
          : (autoCode
            ? 'Auto-filled from name — use the icon to regenerate or turn Auto off to type manually'
            : 'Unique identifier — lowercase letters, numbers, and underscores'))
      }
      onChange={(e) => {
        onAutoCodeChange(false);
        onChange(e.target.value.toLowerCase().replace(/[^a-z0-9_]/g, ''));
      }}
      InputProps={showAutoControls ? {
        endAdornment: (
          <InputAdornment position="end">
            <Stack direction="row" alignItems="center" spacing={0.25}>
              <Tooltip title="Auto-fill code from name">
                <span>
                  <IconButton
                    size="small"
                    edge="end"
                    aria-label="Auto-fill code from name"
                    disabled={!name.trim()}
                    onClick={() => {
                      onAutoCodeChange(true);
                      onChange(slugifyDocumentCode(name));
                    }}
                  >
                    <AutoFixHigh fontSize="small" />
                  </IconButton>
                </span>
              </Tooltip>
              <FormControlLabel
                sx={{ mr: 0, ml: 0.25 }}
                control={(
                  <Switch
                    size="small"
                    checked={autoCode}
                    onChange={(e) => {
                      const on = e.target.checked;
                      onAutoCodeChange(on);
                      if (on) onChange(slugifyDocumentCode(name));
                    }}
                  />
                )}
                label="Auto"
              />
            </Stack>
          </InputAdornment>
        ),
      } : undefined}
    />
  );
}
